import { useMemo } from 'react'
import { isEmpty, isNonNullish } from 'remeda'
import { useMediaQuery } from 'usehooks-ts'
import { getMediaSources } from '@velasca/utils/get-media-sources'
import { SansTitle } from '../SansTitle/SansTitle'
import { SerifTitle } from '../SerifTitle/SerifTitle'
import {
  Background,
  Description,
  Frame,
  Image,
  ImageWrapper,
} from './AboutUsBlock.styles'
import type { AboutUsBlockProps } from './AboutUsBlock.types'

export const AboutUsBlock = ({
  mobileImage,
  desktopImage,
  upperTitle,
  title,
  cta,
}: AboutUsBlockProps): JSX.Element | null => {
  const mediaSources = useMemo(
    () =>
      mobileImage && desktopImage && getMediaSources(mobileImage, desktopImage),
    [mobileImage, desktopImage],
  )
  const fallbackImage = mediaSources ? mediaSources[0] : null
  const isMinWidth768px = useMediaQuery('(min-width: 768px)')

  if (!mobileImage && !desktopImage && !title && !upperTitle && !cta.url) {
    return null
  }

  return (
    <Background>
      <Frame>
        <ImageWrapper>
          {isNonNullish(fallbackImage) && !isEmpty(fallbackImage) && (
            <Image
              lazyload
              lqip
              mediaSources={mediaSources ?? undefined}
              alt={fallbackImage.alt}
              sources={fallbackImage.sources}
              imgSrc={fallbackImage.imgSrc}
            />
          )}
        </ImageWrapper>

        <Description href={cta.url}>
          <SansTitle
            tracking="wide"
            size={isMinWidth768px ? 'base' : 'sm'}
            as="h3"
          >
            {upperTitle}
          </SansTitle>
          <SerifTitle as="h2" size={isMinWidth768px ? 'xl' : 'md'}>
            {title}
          </SerifTitle>
        </Description>
      </Frame>
    </Background>
  )
}
